import "./index.scss";
import React from "react";
import classNames from "classnames";

type LoaderProps = {
  loading: boolean;
  full?: boolean;
  block?: boolean;
};

export default function Loader({
  block = false,
  loading,
  full = false,
}: LoaderProps) {
  const contentClass = classNames("Loader", {
    "Loader--full": full,
    "Loader--block": full ? false : block,
  });
  return loading === true ? (
    <div className={contentClass}>
      <div className="Loader__content">
        <div className="Loader__image" />
      </div>
    </div>
  ) : null;
}
